// extracted by mini-css-extract-plugin
module.exports = {"orderCard":"styles_orderCard__3v7MM","imageContainer":"styles_imageContainer__xFalZ","image":"styles_image__YRUxi"};